@import 'styles/variables';
@import 'styles/mixins';

.mailboxPng {
  height: 48px;
  width: 48px;
  margin-bottom: 16px;
}

.emailText {
  @include inter-semibold;
  font-size: 16px;
  line-height: 28px;
  text-align: center;
  color: var(--neutral-90);
  margin-bottom: 110px;
}

.linkWrapperText {
  display: flex;
  justify-content: center;
  gap: 4px;
}
